'use client';

import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { subscribeSheetMessages } from './NewsletterSheet.messages';
import { Page1Form } from './Page1.client';

const ResultPage = ({
  headline,
  text,
  ref,
}: {
  headline: string;
  text: string;
  ref: RefObject<HTMLDivElement | null>;
}) => (
  <div className="mx-auto my-0 max-w-2xl p-2" ref={ref} tabIndex={-1}>
    <p className="text-size-h3 mb-2.5">{headline}</p>
    <div className="text-size-body2 pb-2.5">{text}</div>
  </div>
);

/**
 * A compact Newsletter Subscribe Form with a simple success page after successful submit
 */

export const NewsletterSubscribeCompact = ({ closeNlSheet }: { closeNlSheet?: () => void }) => {
  const intl = useIntl();
  const [page, setPage] = useState(1);

  const page2Ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (page !== 1) {
      // focus the success message to inform screenreader users and avoid focus loss after submit
      page2Ref.current?.focus();
    }
  }, [page]);

  switch (page) {
    case 2:
      return (
        <ResultPage
          ref={page2Ref}
          headline={intl.formatMessage(subscribeSheetMessages.successHeadline)}
          text={intl.formatMessage(subscribeSheetMessages.successContent)}
        />
      );
    case 3:
      return (
        <ResultPage
          ref={page2Ref}
          headline={intl.formatMessage(subscribeSheetMessages.headlineKnownUser)}
          text={intl.formatMessage(subscribeSheetMessages.descriptionKnownUser)}
        />
      );
    default:
      return (
        <Page1Form
          onSuccess={() => setPage(2)}
          onUserKnown={() => setPage(3)}
          closeNlSheet={closeNlSheet}
        />
      );
  }
};
